import { render, staticRenderFns } from "./SettingBtn.vue?vue&type=template&id=2878951d&scoped=true&"
import script from "./SettingBtn.vue?vue&type=script&lang=js&"
export * from "./SettingBtn.vue?vue&type=script&lang=js&"
import style0 from "./SettingBtn.vue?vue&type=style&index=0&id=2878951d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878951d",
  null
  
)

export default component.exports